import { AnalyticsProvider } from './analytics/AnalyticsContext.js';
import { AnalyticsShell } from './analytics/AnalyticsShell.js';

/**
 * Dashboard (Track B) — the multi-view operational analytics workspace.
 *
 * The `/dashboard` route mounts the analytics section: a shared date-control
 * context (URL-persisted) feeding an Overview/Pulse view plus the analytical
 * domain views (Staff, Schedule, Clients, Care gaps, Documentation, Impact) and
 * a preserved legacy Monitor view. Permission-gated (`dashboard:read`) at the
 * route boundary; every figure is the backend's own number.
 */
export function Dashboard() {
  return (
    <AnalyticsProvider>
      <AnalyticsShell />
    </AnalyticsProvider>
  );
}
